import { partitionIntoOverlappingGroups } from 'components/chart/TrendTimeline/Timeline';
import { timeToPercentage } from 'components/chart/TrendTimeline/TrendTimeline';
import { getBrushTimes } from 'containers/chart/TrendTimelineContainer';
import _ from 'lodash';
import moment from 'moment';
import createCachedSelector from 're-reselect';
import { CHART_TYPE, CHART_VIEW, DATE_FORMAT } from 'utils/constants';
import { getCompareTrend, getTimelineTrends } from '..';
import * as fromState from '../../../reducers';

export const getTrendTimelineHeight = createCachedSelector(
  [
    fromState.getExpandTrendTimeline,
    getTimelineTrends,
    fromState.getToDate,
    state => fromState.getQuickRange(state, CHART_TYPE.MAIN),
    fromState.getBrushStartTimestamp,
    fromState.getBrushEndTimestamp,
    fromState.getView,
    getCompareTrend,
    (state, chartType) => chartType
  ],
  (
    expandTrendTimeline,
    trends,
    toDate,
    quickRange,
    brushStartTimestamp,
    brushEndTimestamp,
    view,
    compareTrend,
    chartType
  ) => {
    if (!expandTrendTimeline) {
      return 50;
    };

    const [brushStartTime, brushEndTime] = view === CHART_VIEW.TIME_SERIES
      ? getBrushTimes(brushStartTimestamp, brushEndTimestamp)
      : [null, null];
    const quickRangeDuration = moment.duration(quickRange);
    let endTime, startTime;
    if (chartType === CHART_TYPE.COMPARE) {
      endTime = brushEndTime || compareTrend.to;
      startTime = brushStartTime
        || moment.utc(compareTrend.to).subtract(quickRangeDuration).toISOString();
    } else {
      endTime = brushEndTime || moment.utc(toDate, DATE_FORMAT);
      startTime = brushStartTime
        || moment.utc(toDate, DATE_FORMAT).subtract(quickRangeDuration).toISOString();
    };

    const startMoment = moment(startTime);
    const endMoment = moment(endTime);

    const items = _.chain(trends)
      .map(trend => ({
        start: timeToPercentage(trend.from, startMoment, endMoment),
        end: timeToPercentage(trend.to, startMoment, endMoment),
        trend,
        highlighted: (compareTrend && compareTrend.id) === trend.id
      }))
      .filter(trend => trend.end > 0 && trend.start < 100)
      .value();
    const overlappingGroups = partitionIntoOverlappingGroups(items);
    const maxOverlap = _.chain(overlappingGroups)
      .maxBy(group => group.overlap)
      .get('overlap')
      .value() || 1;
    return _.clamp(25 * maxOverlap, 50, 300);
  }
)(
  (state, chartType) => chartType
);